const currencySymbols = { EUR: "€", USD: "$", GBP: "£", TRY: "₺" } as const;

export function formatMoney(amount: string, currency: keyof typeof currencySymbols) {
  const [integer, fraction = "00"] = amount.split(".");
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${currencySymbols[currency]}${grouped},${fraction.padEnd(2, "0").slice(0, 2)}`;
}

export function formatPublicDate(value: Date) {
  return new Intl.DateTimeFormat("tr-TR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(value);
}

export function formatPublicTime(value: Date | null) {
  if (!value) return null;
  return new Intl.DateTimeFormat("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC",
  }).format(value);
}

export function priceBasis(unit: string, adults: number, children: number) {
  const unitLabel =
    unit === "PER_PERSON"
      ? "kişi başı"
      : unit === "PER_CABIN"
        ? "kabin başı"
        : "toplam grup";
  const occupancy = [
    adults ? `${adults} yetişkin` : "",
    children ? `${children} çocuk` : "",
  ]
    .filter(Boolean)
    .join(" + ");
  return occupancy ? `${unitLabel} · ${occupancy}` : unitLabel;
}

export function freshnessLabel(checkedAt: Date, now = new Date()) {
  const hours = Math.max(0, (now.getTime() - checkedAt.getTime()) / 3_600_000);
  if (hours <= 24) return "Son 24 saatte kontrol edildi";
  if (hours <= 72) return "Son 3 gün içinde kontrol edildi";
  return "Son 7 gün içinde kontrol edildi";
}

export function compareMoneyStrings(left: string, right: string) {
  const normalize = (value: string) => {
    const [rawInteger, fraction = ""] = value.split(".");
    return {
      integer: rawInteger.replace(/^0+(?=\d)/, ""),
      fraction: fraction.replace(/0+$/, ""),
    };
  };
  const a = normalize(left);
  const b = normalize(right);
  if (a.integer.length !== b.integer.length)
    return a.integer.length < b.integer.length ? -1 : 1;
  if (a.integer !== b.integer) return a.integer < b.integer ? -1 : 1;
  const length = Math.max(a.fraction.length, b.fraction.length);
  const aFraction = a.fraction.padEnd(length, "0");
  const bFraction = b.fraction.padEnd(length, "0");
  return aFraction === bFraction ? 0 : aFraction < bFraction ? -1 : 1;
}
